var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 96,
    viewBox: "0 0 84 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2863_28313)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.5363 50.4351H54.5592",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8609 50.4351H65.8762",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4625 50.4351H48.4854",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49179 45.2983H22.9174C23.4051 45.2983 23.8471 45.5727 24.0605 46.0071L25.9124 49.7261C26.1257 50.1605 26.5678 50.4348 27.0555 50.4348H66.844C67.5528 50.4348 68.1167 51.0064 68.1167 51.7075V95.7103H0.969284V47.8208C0.969284 46.4262 2.09717 45.2983 3.49179 45.2983Z",
    fill: "#C1E8FF",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3363 59.7554H13.8943C13.3532 59.7554 12.8731 60.0983 12.6902 60.6013L1.57133 94.0035C1.27412 94.8342 1.89141 95.7106 2.77543 95.7106H67.2174C67.7585 95.7106 68.2386 95.3677 68.4215 94.8647L79.5404 61.4624C79.8376 60.6318 79.2203 59.7554 78.3363 59.7554Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6285 23.6704L80.5768 25.4613",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0917 26.734L81.1179 26.5815",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5115 26.7037C78.5115 25.9264 76.0348 23.7316 74.1372 23.602C72.2319 23.4648 70.8754 24.4174 70.784 25.7282C70.6925 27.039 71.8966 28.1898 73.7942 28.3041C75.9738 28.4336 78.5115 27.3743 78.5115 26.7113V26.7037Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8849 27.5191C78.1381 27.2981 75.8442 28.9366 75.1812 30.7199C74.5182 32.5031 75.044 34.0807 76.2786 34.5379C77.5132 34.9952 78.9535 34.1645 79.5937 32.3736C80.3329 30.316 79.5175 27.7096 78.8849 27.5267V27.5191Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9154 27.077C78.4125 26.2921 75.9357 26.5588 74.5106 27.2218C73.0855 27.8848 72.4834 29.1194 72.9483 30.1025C73.4132 31.0856 74.7392 31.4285 76.1567 30.7503C77.7799 29.9653 79.426 27.8696 78.9231 27.077H78.9154Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8909 27.9765C80.6527 27.9765 81.2703 27.359 81.2703 26.5972C81.2703 25.8353 80.6527 25.2178 79.8909 25.2178C79.1291 25.2178 78.5115 25.8353 78.5115 26.5972C78.5115 27.359 79.1291 27.9765 79.8909 27.9765Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.59,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.342 31.1083C70.342 31.1083 64.8854 35.9094 58.7278 33.0744C54.0257 30.9101 46.5573 28.822 42.8916 36.0466C39.0126 43.6903 46.2296 48.56 51.7242 46.0299C55.0012 44.521 56.0148 37.3878 49.6132 37.2964C46.0924 37.243 35.2632 43.4617 37.8314 59.7246",
    stroke: "#1F2025",
    strokeWidth: 0.47,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2863_28313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.6406,
    height: 96,
    fill: "white",
    transform: "translate(0.679688)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachments);
export default __webpack_public_path__ + "static/media/attachments.8acf3f17fb1943b3b8f4d72a27f5613c.svg";
export { ForwardRef as ReactComponent };